import type {
  ClinicalSessionAdministration,
  Id,
} from "../../types";
import type { PremiumMarkerForm } from "./anatomicalDraft";

export function administrationsForSession(
  administrations: ClinicalSessionAdministration[],
  sessionId: string
): ClinicalSessionAdministration[] {
  if (!sessionId) return [];
  return administrations.filter(
    (item) => String(item.session_id) === sessionId
  );
}

export function findAdministration(
  administrations: ClinicalSessionAdministration[],
  administrationId?: Id | string | null
): ClinicalSessionAdministration | undefined {
  if (administrationId === undefined || administrationId === null || administrationId === "") return undefined;
  return administrations.find((item) => String(item.id) === String(administrationId));
}

export function administrationLabel(item: ClinicalSessionAdministration): string {
  const product = item.commercial_name || item.active_ingredient || `Producto #${item.product_id}`;
  const quantity = Number.isFinite(Number(item.prescribed_dose))
    ? ` · ${item.prescribed_dose} ${item.prescribed_unit || ""}`.trimEnd()
    : ` · ${item.administered_quantity}`;
  return `${product}${quantity}${item.lot_number ? ` · lote ${item.lot_number}` : ""}`;
}

export function administrationAutofill(
  item: ClinicalSessionAdministration
): Partial<PremiumMarkerForm> {
  return {
    administrationId: String(item.id),
    product: item.commercial_name || item.active_ingredient || "",
    dose: item.prescribed_dose == null ? String(item.administered_quantity) : String(item.prescribed_dose),
    unit: item.prescribed_unit || "",
  };
}

export function administrationTraceLabel(item?: ClinicalSessionAdministration): string {
  if (!item) return "Administración vinculada no disponible";
  return [
    administrationLabel(item),
    item.expiry_date ? `vence ${item.expiry_date}` : "",
    item.warehouse_name || "",
  ].filter(Boolean).join(" · ");
}
